import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as _ from 'lodash';
import { animateScroll as scroll } from 'react-scroll';
import TextareaAutosize from 'react-textarea-autosize';
import * as actions from '../../../../redux/projects/actions.projects';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import * as microphoneActions from '../../../../redux/microphone/actions.microphone';
import cancelEvent from '../../../../services/mini/cancelEvent';
import ChatBubble from '../ChatBubble/ChatBubble';
import AuthDataBtn from '../AuthDataBtn/AuthDataBtn';
import ChatMessages from '../../../../services/dataKeepers/ChatMessages';
import VisualStateBtn from '../VisualStateBtn/VisualStateBtn';
import { alanDebugInfo } from '../../../../services/mini/alanLogs';
import setCaretAtTheEnd from '../../../../services/mini/setCaretAtTheEnd';
import { Transition } from 'react-transition-group';
import { RoundExpandableButton } from '../../../components/RoundExpandableButton/RoundExpandableButton';
import device from '../../../../services/mini/device';
import isLocalStorageAvailable from '../../../../services/mini/isLocalStorageAvailable';
import { IStore } from '../../../../redux/initialState';
import { Environment } from '../../../../const/environment';
import { ChatMessageType } from '../../../../const/chatMessageType';
import { IClearChatAndDialogParams } from '../../../../redux/projects/saga.projects';
import { Loader, LoaderSize, LoaderTheme } from '../../../components/Loader/Loader';
import { processClickByButtonInChat } from '../../../../../../alan_btn/src/textChat/helpers/processClickByButtonInChat';
import { processClickByButtonInPopup } from '../../../../../../alan_btn/src/textChat/helpers/processClickByButtonInPopup';
import { getCssForCommandsBlock, getCssForTextChatLinks } from '../../../../../../alan_btn/src/styles/chat';
import { getProjectOptionsByEnvironment } from '../../../../services/mini/getProjectOptionsByEnvironment';
import { syncPageState } from '../../../../../../alan_btn/src/autosync';
import { saveDebugChatMessages } from '../../../../services/mini/saveDebugChatMessages';
import { highlightCode, initHighlightJs } from '../../../../../../alan_btn/src/textChat/highlightJs';
import { ChatMessageName } from '../../../../const/chatMessageName';
import { shouldTextBeSavedInChatHistory } from '../../../../../../alan_btn/src/textChat/helpers/shouldTextBeSavedInChatHistory';
const $ = require('jquery');

type DebuggingChatProps = PropsFromRedux & {
    environment: Environment
    showVisualStateBtn: boolean
    showAuthDataBtn: boolean
    showQrCodeBtn: boolean
    expandSendBtn: boolean
};
type DebuggingChatState = {
    updateTsKey: number
    reloadProjectTs: string
    text: string
    placeholder: string
    currentMessageInd: number
    messages: any[] // todo: describe all types of messages
    sentMessages: any[] // todo: describe all types of messages
    ts: Date,
    alanBtnWasAdded: boolean
    isChatExporting: boolean
    isScrolling?: boolean
};

class DebuggingChat extends React.Component<DebuggingChatProps, DebuggingChatState> {

    placeholder: string;
    scrollPositionBeforeOpenningPanel: null | number;
    textarea = React.createRef<HTMLTextAreaElement>();
    tryMessageInterval: null | ReturnType<typeof setTimeout> = null;
    tryMessageTimeout: null | ReturnType<typeof setTimeout> = null;
    _isMounted: boolean;
    _isMsgTypingInProcess: boolean;
    isAutoScrolling: boolean;
    isAtBottom: boolean;
    timeoutRef;

    constructor(props) {
        super(props);
        this.placeholder = 'Type here to chat or click the microphone';
        this.state = {
            text: '',
            placeholder: this.placeholder,
            currentMessageInd: null,
            messages: ChatMessages.getMessages(),
            sentMessages: this.restoreSentMessages(),
            updateTsKey: null,
            reloadProjectTs: null,
            ts: null,
            alanBtnWasAdded: false,
            isChatExporting: false,
        };

        this.scrollPositionBeforeOpenningPanel = null;
        this.isAtBottom = true;
    }

    componentDidMount() {
        this._isMounted = true;
        this._isMsgTypingInProcess = false;

        window.addEventListener('updateChat', this.updateChatListener, false);
        window.addEventListener('syncSentMsg', this.syncSentMsg, false);
        window.addEventListener('scrollDebugChatToBubble', this.scrollDebugChatToBubble, false);
        window.addEventListener('message', this.onIFrameSizeListener, false);

        this.createBtnIfNeeded();
        this.updateAlanBtnState();

        this.tryMessageTimeout = setTimeout(() => {
            const { project } = this.props;
            if (project && project.tryMessage) {
                const tryMessage = project.tryMessage;
                alanDebugInfo(JSON.stringify(tryMessage));
                ChatMessages.addMessage({ ...tryMessage, type: ChatMessageType.Info });
                window.dispatchEvent(new CustomEvent("updateChat"));
                setCaretAtTheEnd(this.textarea.current);

                setTimeout(() => {
                    const phrase = tryMessage.phrases[0];

                    this.tryMessageInterval = setInterval(() => {
                        const { text } = this.state;
                        this.setState({ text: phrase.substr(0, text.length + 1) });
                        if (text === phrase) {
                            clearInterval(this.tryMessageInterval);
                            setCaretAtTheEnd(this.textarea.current);
                        }
                    }, 150);
                });
            }
        }, 3000);

        this.scrollToSavedPosition();

        initHighlightJs('light');
        this.highlightCodeBlocks();
    }

    componentDidUpdate = (prevProps, prevState) => {
        this.createBtnIfNeeded();
        if (this.props.isProjectConnected) {
            this.updateAlanBtnState(prevProps);
        }
        this.highlightCodeBlocks();
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('updateChat', this.updateChatListener, false);
        window.removeEventListener('scrollDebugChatToBubble', this.scrollDebugChatToBubble, false);
        window.removeEventListener('message', this.onIFrameSizeListener, false);
        window.addEventListener('syncSentMsg', this.syncSentMsg, false);
        if (window.alanBtnInstance) {
            window.alanBtnInstance.remove();
        }

        clearTimeout(this.tryMessageTimeout);
        clearTimeout(this.tryMessageInterval);
    }

    shouldComponentUpdate(nextProps, nextState) {
        var curProps = this.props,
            curState = this.state;

        if (curState.placeholder !== nextState.placeholder ||
            curState.text !== nextState.text ||
            curState.updateTsKey !== nextState.updateTsKey ||
            curProps.environment !== nextProps.environment ||
            curProps.isModelActual !== nextProps.isModelActual ||
            curProps.isProjectConnected !== nextProps.isProjectConnected ||
            curProps.visualStatePanelOpened !== nextProps.visualStatePanelOpened ||
            curProps.authDataPanelOpened !== nextProps.authDataPanelOpened ||
            curProps.selectedVisualStateTs !== nextProps.selectedVisualStateTs ||
            (curProps.project && nextProps.project && curProps.project.scripts.length !== nextProps.project.scripts.length) ||
            (curProps?.project?.connectDetails !== nextProps?.project?.connectDetails) ||
            curState.reloadProjectTs !== nextState.reloadProjectTs ||
            curState.isChatExporting !== nextState.isChatExporting ||
            curState.isScrolling !== nextState.isScrolling
        ) {
            return true;
        }

        return false;
    }

    highlightCodeBlocks = () => {
        highlightCode(document.querySelector('.debugging-chat'));
    }

    createBtnIfNeeded = () => {
        if (this.props.isProjectConnected === true && this.state.alanBtnWasAdded === false) {
            this.setState({ alanBtnWasAdded: true });
            window.alanBtnInstance = window.alanBtn({
                rootEl: document.getElementById('alan-btn'),
                mode: 'tutor',
                position: 'absolute',
                left: 17,
                bottom: 55,
                hideRecognizedText: true,
                showOverlayOnMicPermissionPrompt: true,
                onBeforeMicStart: this.onBeforeMicStart,
                onMicStarted: this.onMicStarted,
                onMicStopped: this.onMicStopped,
            });
        }
    }

    updateAlanBtnState = (prevProps?) => {
        const { project, environment } = this.props;
        if (window.alanBtnInstance) {
            if (project?.connectDetails?.status !== prevProps?.project?.connectDetails?.status) {
                window.alanBtnInstance.updateButtonState(project.connectDetails.status);
            }

            if (project?.[`${environment}Options`] !== prevProps?.project?.[`${environment}Options`]) {
                try {
                    window.alanBtnInstance.setOptions(JSON.parse(project[`${environment}Options`]));
                } catch (e) {

                }
            }
        }
    }

    rememberChatScrollPosition = () => {
        const $chat = $(this.refs.messages);
        this.scrollPositionBeforeOpenningPanel = $chat[0].scrollTop;
        this.saveScrollPosition();
    }

    openVisualStatePanel = () => {
        this.scrollPositionBeforeOpenningPanel = null;
        this.props.showVisualStatePanel();
    }

    openAuthDataPanel = () => {
        this.props.showAuthDataPanel();
    }

    saveChat = async () => {
        const { project } = this.props;
        const { isChatExporting } = this.state;

        if (isChatExporting) return;

        this.setState({ isChatExporting: true });


        try {
            await saveDebugChatMessages(project);
            this.setState({ isChatExporting: false });
        } catch (error) {
            this.setState({ isChatExporting: true });
        }
    }

    clearChat = () => {
        const { project, environment, clearChatAndDialog } = this.props;
        if (window.alanBtnInstance) {
            window.alanBtnInstance.remove();
            this.setState({ alanBtnWasAdded: false }, () => {
                clearChatAndDialog({
                    project, environment
                });
                this.createBtnIfNeeded();
            });
        }
    }

    scrollDebugChatToBubble = (e) => {
        const ts = e.detail.ts;
        const $chat = $(this.refs.messages);
        const $bubble = $(`[data-bubble-ts="${ts}"]`, $chat);

        if ($bubble.length && $bubble[0].offsetParent) {
            $chat.animate({
                scrollTop: $bubble[0].offsetParent.offsetTop - 50
            }, 300, () => {
                this.rememberChatScrollPosition();
            });
        }
    }

    updateChatListener = (e) => {
        if (!this._isMounted) return;
        if (e && e.type === 'updateChat') {
            this.updateMessages();
        }
    }

    syncSentMsg = (e) => {
        if (!this._isMounted) return;
        if (e && e.type === 'syncSentMsg') {
            this.saveSentMessages(e.detail.text);
        }
    }

    updateMessages = () => {
        if (!this._isMounted) return;
        var messages = ChatMessages.getMessages();
        this.setState({ messages: messages, reloadProjectTs: Date.now() + '_' + messages.length }, () => {
            this.scrollToBottom();
        });
    }

    onBeforeMicStart = () => {
        this.reloadProject();
    }

    onMicStarted = () => {
        window.alanUi.micActive = true;
    }

    onMicStopped = () => {
        this.props.stopMicrophone();
        window.alanUi.micActive = false;
    }

    scrollToSavedPosition = () => {
        const { project } = this.props;
        const chatEl = this.refs.messages as HTMLDivElement;
        if (isLocalStorageAvailable()) {
            const savedYPos = localStorage.getItem(`chat-scroll-y-${project.projectId}`);
            if (savedYPos) {
                chatEl.scrollTop = +savedYPos;
            }
        }
    }

    onIFrameSizeListener = () => {
        this.scrollToBottom();
    }

    onScroll = () => {
        this.setState({ isScrolling: true })
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }

        this.timeoutRef = setTimeout(() => {
            this.setState({ isScrolling: false });
        }, 50);
    };

    onWheel = () => {
        const chatEl = this.refs.messages as HTMLDivElement;
        const { scrollTop, scrollHeight, clientHeight } = chatEl;
        const isBottom = scrollHeight - scrollTop <= clientHeight;

        this.isAtBottom = isBottom;

        this.saveScrollPosition();
    };

    scrollToBottom = _.throttle(() => {
        if (this.isAtBottom) {
            scroll.scrollToBottom({
                containerId: "debug-chat-messges",
                duration: 400,
                delay: 0,
                smooth: "linear",
            });
        }
    }, 200);

    saveScrollPosition = () => {
        const { project } = this.props;
        const chatEl = this.refs.messages as HTMLDivElement;
        if (chatEl) {
            $(chatEl).stop();

            if (isLocalStorageAvailable()) {
                localStorage.setItem(`chat-scroll-y-${project.projectId}`, chatEl.scrollTop.toString());
            }
        }
    }

    onFocus = () => {
        this.setState({ placeholder: '' });
        this.syncPageState();
    }

    syncPageState = () => {
        if (!this._isMsgTypingInProcess) {
            syncPageState(() => {
                this._isMsgTypingInProcess = true;
            });
        }
    }

    onBlur = () => {
        this.setState({ placeholder: this.placeholder });
    }

    onChange = (e) => {
        this.reloadProject();
        this.setState({ text: e.target.value });
    }

    sendQrCode = () => {
        this.props.sendProjectQrCode();
    }

    addNewLine = (textarea) => {
        const { text } = this.state;
        let newText;
        if (textarea.selectionStart === textarea.selectionEnd) {
            const textAsArr = text.split('');
            textAsArr.splice(textarea.selectionStart, 0, '\n');
            newText = textAsArr.join('');
        } else {
            newText = text + '\n';
        }
        this.setState({ text: newText });
    }

    reloadProject = () => {
        const { reloadProjectTs, reloadProject } = this.props;
        if (reloadProjectTs) {
            console.info('reloadProject');
            reloadProject();
        }
    }

    onKeyDown = (e) => {
        const keyCode = e.keyCode || e.which;

        this.syncPageState();

        if (keyCode === 13 && (e.shiftKey)) {
            return;
        }

        if (keyCode === 13 && (e.ctrlKey || e.metaKey)) {
            this.addNewLine(e.currentTarget);
            return;
        }

        e.target.style.whiteSpace = 'nowrap';

        const isMultiLine = e.target.scrollWidth !== e.target.offsetWidth || e.target.value.match('\n');

        e.target.style.whiteSpace = null;

        const goToPrev = keyCode === 38 && ((e.target.selectionStart === 0 && isMultiLine) || !isMultiLine);

        const goToNext = keyCode === 40 && ((e.target.selectionStart === e.target.value.length && isMultiLine) || !isMultiLine);

        if (goToPrev || goToNext) {
            this.switchMessages(keyCode);
            cancelEvent(e);
            return;
        }

        if (keyCode === 13) {
            cancelEvent(e);
            this.send();
        }
    }

    switchMessages = (keyCode) => {
        let { currentMessageInd } = this.state;
        const { sentMessages } = this.state;
        let messages = [...sentMessages];
        messages = messages.reverse();

        if (messages.length === 0) {
            return;
        }

        if (keyCode === 38) {
            if (currentMessageInd === null || currentMessageInd + 1 === messages.length) {
                currentMessageInd = 0;
            } else {
                currentMessageInd = currentMessageInd + 1;
            }
        }

        if (keyCode === 40) {
            if (currentMessageInd === null || currentMessageInd - 1 === -1) {
                currentMessageInd = messages.length - 1;
            } else {
                currentMessageInd = currentMessageInd - 1;
            }
        }
        this.setState({
            currentMessageInd: currentMessageInd,
            text: messages[currentMessageInd]
        });
    }

    saveSentMessages = (text) => {
        if (isLocalStorageAvailable()) {
            const { projectId } = this.props.project;
            const maxSavedForHistoryMsgCount = 25;
            const key = `alan-chat-sent-history-${projectId}`;
            let { sentMessages } = this.state;

            if (!shouldTextBeSavedInChatHistory(text, sentMessages)) return;

            sentMessages.push(text);
            if (sentMessages.length > 50) {
                sentMessages = sentMessages.slice(Math.max(sentMessages.length - maxSavedForHistoryMsgCount, 0));
            }
            this.setState({ sentMessages });
            if (sentMessages.length > 0) {
                localStorage.setItem(key, JSON.stringify(sentMessages));
            }
        }
    }

    restoreSentMessages = () => {
        let messages = [];
        if (isLocalStorageAvailable()) {
            const { projectId } = this.props.project;
            const key = `alan-chat-sent-history-${projectId}`;
            try {
                messages = JSON.parse(localStorage.getItem(key)) || [];
            } catch (e) {

            }
        }
        return messages;
    }

    send = () => {
        const { text } = this.state;

        if (text.trim().length > 0) {
            this.props.sendMessage(text);
            this.saveSentMessages(text);
            this.setState({ text: '', currentMessageInd: null });
            this._isMsgTypingInProcess = false;
        }
    }

    onTextChatPopupClick = (e) => {
        const clickedEl = e.currentTarget.closest('alan-chat__chat-btn');
        if (clickedEl) {
            processClickByButtonInPopup(clickedEl, window.alanBtnInstance, (text) => {
                this.props.sendMessage(text);
                this.saveSentMessages(text);
            });
        }
    }

    onTextChatButtonClick = (e) => {
        const clickedEl = e.target;
        processClickByButtonInChat(clickedEl, window.alanBtnInstance, (text) => {
            this.props.sendMessage(text);
            this.saveSentMessages(text);
        });
        cancelEvent(e);
    }


    upd(w, p, e) {
        window['w' + w + '_' + p] = e.target.value;
        this.setState({ ts: new Date() });
    }

    render() {
        const { text, placeholder, messages, alanBtnWasAdded, isChatExporting, isScrolling } = this.state;
        const {
            environment,
            project,
            visualStatePanelOpened,
            visualStates,
            authDataPanelOpened,
            authData,
            showVisualStateBtn,
            showAuthDataBtn,
            showQrCodeBtn,
            expandSendBtn,
            isModelActual,
        } = this.props;

        const disableBootomPanel = visualStatePanelOpened || authDataPanelOpened;
        const connectionStatus = project?.connectDetails?.status;
        const hasConnectionProblems = connectionStatus === 'error' || connectionStatus === 'disconnected';

        const textChatOptions = getProjectOptionsByEnvironment(project, 'web', environment, [], null)['web']?.chatOptions?.textChat;

        return (
            <div className={`debugging-chat ${environment} ${device.isDesktop() && 'desktop'}`}>
                {hasConnectionProblems &&
                    <div className="debugging-chat_model-sync-panel project-connection-err-loader">
                        Connection failed, retrying...
                    </div>
                }
                {(!isModelActual && !hasConnectionProblems) &&
                    <div className="debugging-chat_model-sync-panel model-loader">Model is updating...</div>
                }
                <style>
                    {`${getCssForTextChatLinks('', {})}`}
                    {`${getCssForCommandsBlock('', textChatOptions)}`}
                </style>
                <div
                    className={`debugging-chat_messages ${messages.length === 0 && 'no-messages'} ${isScrolling && 'scrolling'}`}
                    onWheel={this.onWheel}
                    onScroll={this.onScroll}
                    id="debug-chat-messges"
                    ref="messages">
                    <div className="debugging-chat_messages_empty-block"></div>
                    {messages.length === 0 ?
                        <div className={`debugging-chat_no-messages ${environment}`}>
                            <div className="debugging-chat_no-messages_img" />
                            <div>Debugging Chat</div>
                        </div> :
                        messages.map((message, i) => {
                            const isInfo = message.type === ChatMessageType.Info;
                            const key = message.ui_id;
                            const defaultTransform = isInfo ? 'translateX(400px)' : 'translateX(0px)';

                            const duration = isInfo ? 400 : 200,
                                timeout = {
                                    appear: 2 * duration,
                                    enter: 2 * duration,
                                    exit: duration,
                                },
                                defaultStyle = {
                                    transition: `transform ${duration}ms ease-in-out, opacity ${duration}ms ease-in-out`,
                                    transform: defaultTransform,
                                    opacity: 0,
                                },
                                transitionStyles = {
                                    entering: { transform: defaultTransform, opacity: 0 },
                                    entered: { transform: 'translateX(0px)', opacity: 1 },
                                    exiting: { transform: 'translateX(0px)', opacity: 0 },
                                    exited: { transform: 'translateX(0px)', opacity: 0 },
                                };

                            return <Transition
                                in={true}
                                appear={true}
                                timeout={timeout}
                                key={key}>
                                {(state) => (
                                    <div style={{
                                        ...defaultStyle,
                                        ...transitionStyles[state]
                                    }}>
                                        <ChatBubble
                                            message={message}
                                            project={project}
                                            key={key}
                                            ts={message.ts}
                                            environment={environment}
                                            visualStatePanelOpened={visualStatePanelOpened}
                                            rememberChatScrollPosition={this.rememberChatScrollPosition}
                                            showFullCommands={this.props.showFullCommands}
                                            showFullVisualState={this.props.showFullVisualState}
                                            selectVisualState={this.props.selectVisualState}
                                            selectedVisualStateTs={this.props.project.selectedVisualStateTs}
                                            onTextChatPopupClick={this.onTextChatPopupClick}
                                            onTextChatButtonClick={this.onTextChatButtonClick} />
                                    </div>)}
                            </Transition>;
                        })}
                </div>
                <div className={`debugging-chat_send-panel ${!placeholder && 'focused'} ${text && 'filled'}`}>
                    <TextareaAutosize
                        minRows={2}
                        maxRows={15}
                        ref={this.textarea}
                        value={text}
                        onKeyDown={this.onKeyDown}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                    />
                    <div className="debugging-chat_send-panel_top-btns">
                        <div>
                            <RoundExpandableButton
                                label="Clear dialog"
                                onClick={this.clearChat}
                                className="debugging-chat_clear-msgs-btn">
                                <div className="debugging-chat_clear-msgs-btn">
                                    <i className="icon icon-alan-trash" />
                                </div>
                            </RoundExpandableButton>
                            {showQrCodeBtn &&
                                <RoundExpandableButton
                                    label="Scan QR"
                                    disabled={!project.connectDetails.dialogId || disableBootomPanel}
                                    className="debug-chat_qr-code-btn"
                                    onClick={this.sendQrCode} >
                                    <div className="debugging-chat_send-panel_top-btns_qr-code-btn">
                                        <i className="icon icon-alan-qr-code-small qr-code-icon" />
                                    </div>
                                </RoundExpandableButton>}
                            {showVisualStateBtn &&
                                <RoundExpandableButton
                                    value={visualStates.length > 0}
                                    label={`${visualStates.length > 0 ? 'Edit' : 'Set'} Visual State`}
                                    disabled={disableBootomPanel}
                                    className="debug-chat_vs-btn"
                                    onClick={this.openVisualStatePanel}>
                                    <VisualStateBtn visualStatePanelOpened={this.props.visualStatePanelOpened} />
                                </RoundExpandableButton>}
                            {showAuthDataBtn &&
                                <RoundExpandableButton
                                    value={authData}
                                    label={`${authData ? 'Edit' : 'Set'} Auth Data`}
                                    disabled={disableBootomPanel}
                                    className="debug-chat_auth-btn"
                                    onClick={this.openAuthDataPanel} >
                                    <AuthDataBtn
                                        authData={authData}
                                        classes={`auth-data-panel-position`}
                                        placeholderClass="auth-data-panel-placeholder"
                                        authDataPanelOpened={this.props.authDataPanelOpened} />
                                </RoundExpandableButton>}
                            <RoundExpandableButton
                                label={`Export chat`}
                                disabled={disableBootomPanel}
                                className={`debug-chat_auth-btn ${isChatExporting ? 'disabled' : ''}`}
                                onClick={this.saveChat} >
                                <div className="debugging-chat_save-chat-btn">
                                    <i className="icon icon-alan-load-down" />
                                </div>
                            </RoundExpandableButton>
                        </div>
                        <div className="debugging-chat_send-panel_top-btns_right-part">
                            <RoundExpandableButton
                                label="Send"
                                expanded={text && expandSendBtn}
                                disabled={disableBootomPanel || !text}
                                onClick={this.send} >
                                <div className={`debugging-chat_send-btn ${text && 'shown'}`}>
                                    <i className="icon icon-alan-send" />
                                </div>
                            </RoundExpandableButton>
                        </div>
                    </div>
                </div>
                <div id="alan-btn" />
                {!alanBtnWasAdded && <div id="alan-btn-ghost">
                    <Loader size={LoaderSize.SuperSmall} theme={LoaderTheme.Dark} />
                </div>}
            </div>
        );
    }
}


function mapStateToProps({ projectsInfo }: IStore, ownProps) {

    const {
        reloadProjectTs,
        isModelActual,
        authData,
        visualStates,
        selectedVisualStateTs,
        visualStatePanelOpened,
        authDataPanelOpened
    } = projectsInfo.currentProject;

    return {
        reloadProjectTs,
        isModelActual,
        authData,
        visualStates,
        selectedVisualStateTs,
        visualStatePanelOpened,
        authDataPanelOpened,
        project: projectsInfo.currentProject,
        isProjectConnected: projectsInfo.currentProject.isProjectConnected
    };
}

function mapDispatchToProps(dispatch) {
    return {
        sendMessage: (text) => dispatch(actions.sendMessage(text)),
        sendProjectQrCode: () => dispatch(actions.sendProjectQrCode()),
        showVisualStatePanel: () => dispatch(actions.showVisualStatePanel()),
        showAuthDataPanel: () => dispatch(actions.showAuthDataPanel()),
        showFullVisualState: (param) => dispatch(actions.showFullVisualState(param)),
        highlightLine: (param) => dispatch(scriptEditorActions.highlightLine(param)),
        showFullCommands: (param) => dispatch(actions.showFullCommands(param)),
        reloadProject: () => dispatch(actions.reloadProject()),
        stopMicrophone: () => dispatch(microphoneActions.stopMicrophone()),
        selectVisualState: (param) => dispatch(actions.selectVisualState(param)),
        clearChatAndDialog: (param: IClearChatAndDialogParams) => dispatch(actions.clearChatAndDialog(param)),
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DebuggingChat);